import { chatWindowActions } from '../redux/slices/chat-window';
import { chatSession } from '../utils/session';

export function fetchNumberOfUnreadMessages() {
  const current = chatSession.getNumberOfUnreadMessages();
  chatSession.setNumberOfUnreadMessages(current);
  return chatWindowActions.updateNumberOfUnreadMessages(current);
}

export function updateNumberOfUnreadMessages() {
  const currentNumber = chatSession.getNumberOfUnreadMessages();
  const newNumber = currentNumber + 1;
  chatSession.setNumberOfUnreadMessages(newNumber);
  return chatWindowActions.updateNumberOfUnreadMessages(newNumber);
}

export function resetNumberOfUnreadMessages() {
  chatSession.setNumberOfUnreadMessages(0);
  return chatWindowActions.resetNumberOfUnreadMessages();
}
